var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-items-management" }, [
    _c(
      "div",
      { staticClass: "client-card-list-wrapper" },
      _vm._l(_vm.clients, function(client, index) {
        return _c("ClientCard", {
          key: client.id,
          attrs: {
            listEM: _vm.listEM,
            client: client,
            isNoTrans: index % 4 == 3,
            isClear: index % 4 == 0
          }
        })
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a084cda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a084cda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/ClientCardsManagement.vue
// module id = 1589
// module chunks = 1